import MainMenu from "../components/Menu/MainMenu/MainMenu";
import InicioAdmin from "../pages/InicioAdmin/Home/InicioAdmin";
import GestionAdministrativo from "../pages/InicioAdmin/GestionDirectivos/GestionAdministrativo";
import GestionDocente from "../pages/InicioAdmin/GestionDocente/GestionDocente";
import GestionPersonalCe from "../pages/InicioAdmin/GestionPersonalCe/GestionPersonalCe";
import Profile from "../pages/Profile/Profile";
import PlanDeEstudios from "../pages/InicioPersonalCE/PlanDeEstudios/PlanDeEstudios";
import Periodos from "../pages/InicioPersonalCE/Periodos/Periodos";
import Grupos from "../pages/InicioPersonalCE/Grupos/Grupos";
import Materias from "../pages/InicioPersonalCE/Materias/Materias";
import Alumnos from "../pages/InicioPersonalCE/Alumnos/Alumnos";
import AlumnosGrupo from "../pages/InicioPersonalCE/Grupos/AlumnosGrupo";
import DatosAlumno from "../pages/InicioPersonalCE/Grupos/DatosAlumno";
import ReinscripcionAlumnos from "../pages/InicioPersonalCE/ReinscripcionAlumnos/ReisncripcionAlumnos";
import ListaAlumnosGrupo from "../pages/InicioPersonalCE/ReinscripcionAlumnos/ListaAlumnosGrupo";
import ListaAlumnosNoIns from "../pages/InicioPersonalCE/Alumnos/ListaAlumnosNoIns";
import DatosAlumnoNoIns from "../pages/InicioPersonalCE/Alumnos/DatosAlumnoNoIns";
import Cursos from "../pages/InicioPersonalCE/Cursos/Cursos";
import ConsultaGrupos from "../pages/InicioPersonalDocente/ConsultaGrupos";
import AsignacionCursos from "../pages/InicioAdmin/GestionDocente/AsignacionCursos";
import AlumnosCurso from "../pages/InicioPersonalCE/Cursos/AlumnosCurso";
import CalificarAlumnosCurso from "../pages/InicioPersonalDocente/CalificarAlumnosCurso/CalificarAlumnosCurso";
import AlumnosEgresados from "../pages/InicioPersonalCE/Alumnos/AlumnosEgresados";
import BoletasAlumnos from "../pages/InicioPersonalCE/BoletasAlumnos/BoletasAlumnos";
import DatosEgresados from "../pages/InicioPersonalCE/Alumnos/DatosEgresados";
import ConstanciasAlumnos from "../pages/InicioPersonalCE/ConstanciasAlumnos/ConstanciasAlumnos";
import { Settings } from "../pages/InicioAdmin/Settings/Settings";
import { BasicLayout } from "../components/basic/BasicLayout";
import { EmailConfirm } from "../pages/Password_reset/Email/EmailConfirm";
import { Password_reset } from "../pages/Password_reset/Password_reset";
import GestionPersonalNA from "../pages/InicioAdmin/GestionPersonalNA/GestionPersonalNA";
import KardexAlumnos from "../pages/InicioPersonalCE/KardexAlumnos/KardexAlumnos";
import PracticantesDisponibles from "../pages/InicioAdmin/GestionDocente/PracticantesProfesionales/PracticantesDisponibles";
import PracticantesAsignados from "../pages/InicioAdmin/GestionDocente/PracticantesProfesionales/PracticantesAsignados";
import CategoriasCargos from "../pages/InicioAdmin/CategoriasCargos/CategoriasCargos";

const routesAdmin = [
  {
    path: "/",
    layout: MainMenu,
    component: InicioAdmin,
  },
  {
    path: "/gestion-docente",
    layout: MainMenu,
    component: GestionDocente,
  },
  {
    path: "/gestion-docente/asignacion-cursos",
    layout: MainMenu,
    component: AsignacionCursos,
  },
  {
    path: "/gestion-docente/practicantes-disponibles",
    layout: MainMenu,
    component: PracticantesDisponibles,
  },
  {
    path: "/gestion-docente/practicantes-asignados",
    layout: MainMenu,
    component: PracticantesAsignados,
  },
  {
    path: "/mis-grupos",
    layout: MainMenu,
    component: ConsultaGrupos,
  },
  {
    path: "/gestion-administrativo",
    layout: MainMenu,
    component: GestionAdministrativo,
  },
  {
    path: "/GestionPersonalCe",
    layout: MainMenu,
    component: GestionPersonalCe,
  },
  {
    path: "/GestionPersonalNA",
    layout: MainMenu,
    component: GestionPersonalNA,
  },
  {
    path: "/Profile",
    layout: MainMenu,
    component: Profile,
  },
  {
    path: "/settings",
    layout: MainMenu,
    component: Settings,
  },
  {
    path: "/PlanDeEstudios",
    layout: MainMenu,
    component: PlanDeEstudios,
  },
  {
    path: "/Periodos",
    layout: MainMenu,
    component: Periodos,
  },
  {
    path: "/Grupos",
    layout: MainMenu,
    component: Grupos,
  },
  {
    path: "/Materias",
    layout: MainMenu,
    component: Materias,
  },
  {
    path: "/Alumnos",
    layout: MainMenu,
    component: Alumnos,
  },
  {
    path: "/Grupos/AlumnosGrupo",
    layout: MainMenu,
    component: AlumnosGrupo,
  },
  {
    path: "/Grupos/AlumnosGrupo/DatosAlumno",
    layout: MainMenu,
    component: DatosAlumno,
  },
  {
    path: "/ReinscripcionAlumnos",
    layout: MainMenu,
    component: ReinscripcionAlumnos,
  },
  {
    path: "/ReinscripcionAlumnos/ListaAlumnosGrupo",
    layout: MainMenu,
    component: ListaAlumnosGrupo,
  },
  {
    path: "/ListaAlumnosNoIns",
    layout: MainMenu,
    component: ListaAlumnosNoIns,
  },
  {
    path: "/ListaAlumnosBajas/DatosAlumno",
    layout: MainMenu,
    component: DatosAlumnoNoIns,
  },
  {
    path: "/cursos",
    layout: MainMenu,
    component: Cursos,
  },
  {
    path: "/cursos/AlumnosCurso",
    layout: MainMenu,
    component: AlumnosCurso,
  },
  {
    path: "/AlumnosEgresados",
    layout: MainMenu,
    component: AlumnosEgresados,
  },
  {
    path: "/mis-grupos/CalificarAlumnosCurso",
    layout: MainMenu,
    component: CalificarAlumnosCurso,
  },
  {
    path: "/AlumnosEgresados/DatosAlumnoEgresado",
    layout: MainMenu,
    component: DatosEgresados,
  },
  {
    path: "/ConstanciasAlumnos",
    layout: MainMenu,
    component: ConstanciasAlumnos,
  },
  {
    path: "/password-reset",
    layout: BasicLayout,
    component: EmailConfirm,
  },
  {
    path: "/reset-password-form/:ref",
    layout: BasicLayout,
    component: Password_reset,
  },
  {
    path: "/boletas-alumnos",
    layout: MainMenu,
    component: BoletasAlumnos,
  },
  {
    path: "/kardex-alumnos",
    layout: MainMenu,
    component: KardexAlumnos,
  },
  {
    path: "/categorias-cargos",
    layout: MainMenu,
    component: CategoriasCargos,
  },
];

export default routesAdmin;
